import React from 'react';
import Section from './section';

const SubSection = props => {
  return <Section formattedTitle={<h5>{props.title}</h5>}
                  className={props.className}
                  noMargin={props.noMargin}>
    {props.children}
  </Section>;
};

export default SubSection;
